import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PayPalReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const orderId = params.get("token");
  const invoiceId = params.get("invoice_id");
  const [state, setState] = useState("processing"); // processing | success | error
  const [message, setMessage] = useState("Confirming your payment with PayPal…");

  useEffect(() => {
    if (!orderId) { setState("error"); setMessage("Missing PayPal order id."); return; }
    axios.post(`${API}/api/paypal/capture/${orderId}`)
      .then((r) => {
        if (r.data.status === "COMPLETED" || r.data.status === "already_captured") {
          setState("success"); setMessage("Payment received. Thank you!");
        } else {
          setState("error"); setMessage(`Payment status: ${r.data.status}`);
        }
      })
      .catch((e) => {
        setState("error"); setMessage(e.response?.data?.detail || "Could not confirm the payment.");
      });
  }, [orderId]);

  return (
    <div className="min-h-screen bg-slate-50 py-12 px-6 grid place-items-center">
      <Card className="border-slate-200 shadow-none p-10 max-w-md w-full text-center">
        {state === "processing" && <Loader2 className="w-10 h-10 mx-auto text-slate-500 animate-spin" />}
        {state === "success" && <CheckCircle2 className="w-12 h-12 mx-auto text-emerald-600" />}
        {state === "error" && <XCircle className="w-12 h-12 mx-auto text-rose-600" />}
        <h1 className="font-heading text-2xl font-semibold mt-4">
          {state === "processing" && "Processing…"}
          {state === "success" && "Payment Received"}
          {state === "error" && "Payment Issue"}
        </h1>
        <p className="text-sm text-slate-500 mt-2">{message}</p>
        {invoiceId && (
          <Button
            variant="outline"
            className="mt-6"
            onClick={() => navigate(`/pay/${invoiceId}`)}
            data-testid="back-to-invoice-btn"
          >
            Back to invoice
          </Button>
        )}
      </Card>
    </div>
  );
}
